export default __webpack_public_path__ + "static/20240829-ddb9a97996310d047b09758519ae3811.png";